<template>
  <div
    class="'w-fit flex items-center overflow-auto rounded-md border bg-white px-3 py-4 lg:max-w-[768px]"
  >
    <p class="text-xs font-medium text-gray-500">{{ $t('stats.noStatsAvailable') }}</p>
  </div>
</template>
